/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { createContext, useReducer } from "react";

export const initialContext = {
  account: {
    loggedIn: false,
  },
  data: {
    sample: null,
  },
  login: {
    verifyPending: false,
    verifyExpiration: null,
  },
  request: {
    token: null,
    requests: [],
    showLoading: false,
    handleSuccess: null,
    handleFailure: null,
  }
};

export const ContextUpdater = createContext(null);
export const AccountContext = createContext(initialContext.account);
export const DataContext = createContext(initialContext.data);
export const LoginContext = createContext(initialContext.login);
export const RequestContext = createContext(initialContext.request);

const reducer = (state, action) => {
  if (!(action.type in state)) {
    throw new Error("ContextProvider.reduce(): action.type not found: " + action.type);
  }
  return {
    ...state,
    [action.type]: {
      ...state[action.type],
      ...action.payload
    }
  };
};

const ContextProvider = ({ children }) => {
  // general statte
  const [state, dispatch] = useReducer(reducer, initialContext);

  // context update
  const contextUpdaterValue = (newState) => {
    Object.entries(newState).forEach(([key, value]) => {
      dispatch({ type: key, payload: value });
    });
  };

  // context update state callbacks
  const contextNames = Object.keys(initialContext);
  const contextValues = {};
  for (const key of contextNames) {
    contextValues[key] = {
      ...state[key],
      updateState: (newState) => dispatch({ type: key, payload: newState })
    };
  }

  return (
    <ContextUpdater.Provider value={contextUpdaterValue}>
    <AccountContext.Provider value={contextValues.account}>
    <DataContext.Provider value={contextValues.data}>
    <LoginContext.Provider value={contextValues.login}>
    <RequestContext.Provider value={contextValues.request}>
      {children}
    </RequestContext.Provider>
    </LoginContext.Provider>
    </DataContext.Provider>
    </AccountContext.Provider>
    </ContextUpdater.Provider>
  );
};

export default ContextProvider;
